<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <contact-person-form v-if="contactPerson"
          @submit="submit"
          :init-contact-person="contactPerson"
          :val-errors="valErrors"
          submit-text="Speichern"
        />
      </card>
    </div>
  </div>
</template>

<script>
import ContactPersonForm from './contact-person-form'

export default {
  components: { ContactPersonForm },
  data () {
    return {
      contactPerson: null,
      valErrors: []
    }
  },
  methods: {
    async submit (contactPerson) {
      await this.initCsrf()

      this.valErrors = []
      const url = this.getUrl(this.contactPerson.supplier_id, this.contactPerson.id)
      this.$http.put(url, contactPerson).then(({ data }) => {
        this.$notify({
          message: 'Ansprechpartner erfolgreich bearbeitet.',
          type: 'success'
        })
        this.redirectBack('/suppliers')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    },
    getUrl (supplierId, contactPersonId) {
      return `/suppliers/${supplierId}/contact_people/${contactPersonId}`
    }
  },
  created () {
    const url = this.getUrl(this.$route.params.sid, this.$route.params.cpid)
    this.$http.get(url).then(({ data }) => {
      this.contactPerson = data
    })
  }
}
</script>

<style>
</style>
